/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import DiscordAnalyticsQueriesDashboard from "../../../../components/DiscordAnalytics/Queries/Dashboard";
import Navbar from "../../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../../constants/routes";

const DiscordAnalyticsQueryDashboard = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.discordAnalytics?.hasQueriesDashboardAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <DiscordAnalyticsQueriesDashboard adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default DiscordAnalyticsQueryDashboard;
